import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const SimpleBreadcrumb = (_param)=>{
    var { className , title , href  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "title",
        "href"
    ]);
    const classes = classnames('store-simple-breadcrumb-stores-v2', className);
    const children = /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "chevron-left"
    }), title);
    return href ? /*#__PURE__*/ React__default.createElement("a", swcHelpers.extends({}, rest, {
        href: href,
        className: classes
    }), children) : /*#__PURE__*/ React__default.createElement("p", swcHelpers.extends({}, rest, {
        className: classes
    }), children);
};
var SimpleBreadcrumb$1 = SimpleBreadcrumb;

export { SimpleBreadcrumb$1 as default };
//# sourceMappingURL=SimpleBreadcrumb.js.map
